module.exports = __webpack_public_path__ + "img/iphone-charging-SWEDEN-sv.d2cb6a5c.webp";